import React, { useLayoutEffect } from 'react';
import { useOidc } from "@axa-fr/react-oidc";

//Handle any unexpected session lost
const CustomSessionLost = () => {
    const { isAuthenticated, logout } = useOidc();

    useLayoutEffect(() => {
        sessionStorage.setItem('signedOut', 'true');
        sessionStorage.setItem('showModal', 'true');

        if (isAuthenticated) {
            setTimeout(function () {
                //Force to log out
                logout();
            }, 5);
        }
        else {
            setTimeout(function () {
                 //Redirect to home page
                const win: Window = window;
                win.location = window.location.origin;
            }, 5);
        }
    });


    return (
        <>
            <h1 className="css_heading bold">Session timed out</h1>
            <div>Your session has expired.</div>
        </>
    );
}


export default CustomSessionLost;